import { createContext } from 'react'

export const PreviewDataContext = createContext(null)
